import { api } from '@/api/api';

export const segmentTemplates = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
    lastChanged: {
      template: null,
      type: 'edit',
    },
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setTemplates(state, templates) {
      state.list = templates;
    },
    addTemplate(state, template) {
      state.list.push(template);
    },
    setLastChanged(state, lastChanged) {
      state.lastChanged = lastChanged;
    },
    resetLastChanged(state) {
      state.lastChanged = {
        template: null,
        type: 'edit',
      };
    },
    toggleFavorite(state, templateId) {
      state.list = state.list.map((t) =>
        t.id === templateId
          ? {
              ...t,
              is_favorite: !t.is_favorite,
            }
          : t
      );
    },
  },
  actions: {
    async fetchTemplates({ rootState, commit }) {
      if (
        rootState.company.currentId === -1 ||
        rootState.company.segment.currentId === -1
      ) {
        return;
      }
      commit('setFetching', true);
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/templates/`
      );
      commit(
        'setTemplates',
        data.map((template) => ({
          ...template,
          campaign: template.campaign && template.campaign.id,
        }))
      );
      commit('setFetching', false);
    },
    async updateTemplate({ rootState, state, commit }, template) {
      const { data } = await api.patch(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/templates/${template.id}/`,
        template
      );
      commit('setLastChanged', {
        template: data,
        type: 'edit',
      });
      commit(
        'setTemplates',
        state.list.map((t) => {
          if (t.id === template.id) {
            return {
              ...data,
              campaign: data.campaign && data.campaign.id,
            };
          }
          return t;
        })
      );
    },
    async addTemplate({ rootState, commit }, template) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/templates/`,
        template
      );
      commit('setLastChanged', {
        template: data,
        type: 'create',
      });
      commit('addTemplate', {
        ...data,
        campaign: data.campaign && data.campaign.id,
      });
    },
    async toggleTemplateFavorite({ rootState, state, commit }, templateId) {
      const existingTemplate = state.list.find((t) => t.id === templateId);
      if (existingTemplate.is_favorite) {
        api.delete(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/remove_favorite_template/${templateId}/`
        );
      } else {
        api.post(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/add_favorite_template/${templateId}/`
        );
      }
      commit(
        'setTemplates',
        state.list.map((t) => {
          if (t.id === templateId) {
            return {
              ...t,
              is_favorite: !t.is_favorite,
            };
          }
          return t;
        })
      );
    },
  },
};
